import { FC } from 'react'
import PageLayout from '../../components/page-layout/page-layout'
import PrintPreparationTable from './components/print-preparation-table/print-preparation-table'
import HelpDrawer from './components/help-drawer/help-drawer'

interface PrintPreparationPageProps {}

const PrintPreparationPage: FC<PrintPreparationPageProps> = () => {
    return (
        <PageLayout title={'Подготовка к печати'} beforeUser={<HelpDrawer />}>
            <PrintPreparationTable />
        </PageLayout>
    )
}

export default PrintPreparationPage
